import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action , Getter , Mutation } from 'vuex-class';


@Component({})
export default class BellNotification extends Vue {

  @Prop({ default: "30px" }) iconWidth;
  @Prop({ default: "30px" }) iconHeight;
  @Prop({ default: false }) hasTooltip;
  @Prop({ default: "" }) message;
  @Prop({ default: "" }) messageActive;
  @Prop({ default: "" }) itemCode;
  @Prop({ default: 'bottom' }) position;
  @Prop({ default: false }) convertToBtn;
  @Prop({ default: false }) alreadyActive;
  @Prop({ default: "" }) productId;


  @Getter getIsToken: any;
  @Getter getUser;

  @Mutation PATH_TEMPORAL: any

  @Action action_postItemNotification

  isTooltipVisible = false;
  isBellActive = false;
  isBellActiveBtn = false;
  isAlreadyActive = false;

  _goToCashbackInfo() {

  }


  async activeBellAlert(cityId , itemId) {
    // if(this.getUser == !null) {
    //   this.isBellActive = true;
    // }
    // else {
    //   this.$router.push({ name: 'login' })
    // }
    if(this.getIsToken) {
      await this.action_postItemNotification({
        idc : cityId,
        idp : itemId
      })
      console.log('Se activo');
      this.isBellActive = true;
    } else {
      const name = this.$route.name
      const query = this.$route.query
      const params = this.$route.params
      this.PATH_TEMPORAL({ name, params, query })
      window.location.href = '/login'
    }
  }

  // _verifyActive() {
  //   for(let item of this.getUser.notification_available_products) {
  //     if(item == this.itemCode) {
  //       this.isAlreadyActive = true;
  //       this.isBellActive = true
  //     }
  //     else {
  //       this.isAlreadyActive = false
  //       this.isBellActive = false
  //     }
  //     console.log(item);
      
  //   }
  // }

  // mounted() {
  //   this._verifyActive()
  // }


  noActiveBellAlert() {
    this.isBellActive = false;
  }
  
  get getTooltipMessage() {
    return this.message;
  }

  get getTooltipMessageActive() {
    return this.messageActive;
  }
}